angular.module("screensApp")

.controller("WinnersController", function ($scope, $rootScope, $timeout, WinnersService) {
  /**
   * Load winners
   */
  var winnersLoadTimeout = null;
  function loadWinners() {
    if (winnersLoadTimeout) $timeout.cancel(winnersLoadTimeout);

    WinnersService.getWinners()
      .success(function (data) {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: getWinners() data: ' + JSON.stringify(data));
        $rootScope.winnersData = data;
        $rootScope.winnersRowListing();
        winnersLoadTimeout = $timeout(loadWinners, $rootScope.settings.winnersLoadInterval);
      })
      .error(function (err) {
        if ($rootScope.bannedCountriesForWinners.indexOf($rootScope.config.Country) != -1) {
          $("#winnersContainer").hide();
        }
        $rootScope.settings.winnersForBanner = false;
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR AJAX: getWinners() err: ' + err);
      });
  }

  // Don't show winners for banned countries
  if ($rootScope.bannedCountriesForWinners.indexOf($rootScope.config.Country) == -1) loadWinners();
  /**
   * Listing throught winners
   */
  $rootScope.winnersRowListing = function () {
    if (!$rootScope.winnersData) {
      // WinnersRow Callback
      $timeout($scope.winnersRowListing, 1000);
      return;
    }
    // Cancel existing timeout
    $timeout.cancel($scope.winnersListing);
    // Set winner
    $scope.actualWinner = $rootScope.winnersData.Winners[$rootScope.winnerIndex];
    // Reset index
    if ($rootScope.winnerIndex == $rootScope.winnersData.Winners.length - 1) $rootScope.winnerIndex = 0;
    // Increase index
    else ++$rootScope.winnerIndex;
    // WinnersRow Callback
    $scope.winnersListing = $timeout($scope.winnersRowListing, $rootScope.settings.winnersRowInterval);
  };

  $scope.todayUpdate = function (date) {
    if (!date) return null;

    date = date.split(".");

    var day = date[0],
      month = date[1],
      actualDay = moment().format("DD"),
      actualMonth = moment().format("MM");

    if (actualDay == day && actualMonth == month) return "today";
    else return "past";
  };
});
